import '@wix/wix-angular';
import 'angular';
import 'angular-dynamic-locale';
import 'angular-translate';
import 'angular-translate-loader-static-files';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import 'commons-validator-js';
import 'jquery';
import 'new-relic-angular-client';
import 'perfect-scrollbar';
import 'perfect-scrollbar/dist/css/perfect-scrollbar.css';
import './styles/icons.css';
import './styles/layout.css';
import './styles/loader.css';
import './app/widget.module';
import { mockStandalone } from './standalone/standalone';

mockStandalone();
